import { render } from "./index.vue?vue&type=template&id=27e74d30&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=27e74d30&lang=less&scoped=true"

import exportComponent from "/Users/zhouti/Desktop/work/fy-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e74d30"]])

export default __exports__